export default {"src":"/_next/static/media/KYB_ICON.1b170047.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};